module.exports = __webpack_public_path__ + "static/shopify_3-58af5b4ec8521cd5b7751640e654a722.png";